export default __webpack_public_path__ + "static/media/logo.800ff118.png";